exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".manu{min-width:150px}.model{min-width:300px}.small-col{max-width:70px}", "", {"version":3,"sources":["/vue-ui/src/views/RimsAdmin.vue"],"names":[],"mappings":"AACA,MACE,eAAiB,CAClB,AACD,OACE,eAAiB,CAClB,AACD,WACE,cAAgB,CACjB","file":"RimsAdmin.vue","sourcesContent":["\n.manu {\n  min-width: 150px;\n}\n.model {\n  min-width: 300px;\n}\n.small-col {\n  max-width: 70px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-740f0022","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/RimsAdmin.vue
// module id = 135
// module chunks = 4